import React, { useEffect, useState, useCallback } from 'react';
import { X, Plus, Trash2 } from 'lucide-react';
import { db, uid } from '../lib/db';
import { useToast } from './Toast';

export const MemoryPanel = ({ open, onClose, onChange }) => {
  const toast = useToast();
  const [mems, setMems] = useState([]);
  const [input, setInput] = useState('');

  const load = useCallback(async () => {
    const list = await db.getAll('global_memory');
    list.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
    setMems(list);
  }, []);

  useEffect(() => { if (open) load(); }, [open, load]);

  const add = async () => {
    const t = input.trim();
    if (!t) return;
    const m = { id: uid(), text: t, createdAt: Date.now() };
    await db.put('global_memory', m);
    setInput('');
    await load();
    onChange?.();
    toast('Mémoire ajoutée', 'success');
  };

  const del = async (id) => {
    await db.delete('global_memory', id);
    await load();
    onChange?.();
  };

  const clearAll = async () => {
    if (!window.confirm('Effacer toute la mémoire globale ?')) return;
    for (const m of mems) await db.delete('global_memory', m.id);
    await load();
    onChange?.();
    toast('Mémoire effacée', 'info');
  };

  return (
    <aside className={`memory-panel ${open ? 'active' : ''}`}>
      <div className='memory-header'>
        <div>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: 13, letterSpacing: 4, color: 'var(--text-bright)' }}>MEMORY</div>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: 9, color: 'var(--cyan)', letterSpacing: 2, marginTop: 2, opacity: 0.7 }}>GLOBAL CONTEXT</div>
        </div>
        <button className='modal-close' onClick={onClose}><X size={14} /></button>
      </div>
      <div className='memory-body'>
        {mems.length === 0 && (
          <div style={{ color: 'var(--text-dim)', fontSize: 12, fontStyle: 'italic', textAlign: 'center', padding: '24px 0' }}>
            Aucun souvenir.<br />Ajoutez des faits que l'IA doit retenir entre conversations.
          </div>
        )}
        {mems.map((m) => (
          <div key={m.id} className='memory-item'>
            <span className='memory-item-text'>{m.text}</span>
            <button className='memory-item-del' onClick={() => del(m.id)} title='Supprimer'><Trash2 size={13} /></button>
          </div>
        ))}
        {mems.length > 0 && (
          <button className='hud-btn danger' style={{ width: '100%', justifyContent: 'center', marginTop: 12 }} onClick={clearAll}>
            <Trash2 size={12} /> TOUT EFFACER
          </button>
        )}
      </div>
      <div className='memory-add'>
        <input
          data-testid='memory-input'
          name='memory-input'
          className='hud-input'
          placeholder='Nouveau souvenir…'
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); add(); } }}
        />
        <button data-testid='memory-add-btn' className='hud-btn primary icon-only' onClick={add}><Plus size={14} /></button>
      </div>
    </aside>
  );
};
